const locale = {
    welcome: 'Welcome!',
    login_into_your_account: 'Login into your account',
    email:'Email',
    password:'Password',
    forgot_password:'Forgot Password',
    login: 'Login',
    need_an_account:'Need an Account?',
    sign_up_now: ' Sign Up Now!',
    account_not_activated: 'Account is not activated',

    set_new_password: 'Set New Password',
    reset_your_password: 'Reset your Password',
    enter_your_previously_email_registered:'Enter the email address associated with your SCAI account.',
    a_generated_code_will_be_send_to_your_email:'A link will be send to your email to reset your password.',
    send_reset_link:'Send reset link',
    go_back_to_login_page: 'Go back to login page',
    password_requirements:'Password have to contains uppercase, lowercase, number, special characters, and a minimum of 8 characters.',
    password_confirm:'Confirm Password',
    resend_verification_email:'Resend verification email',
    back_to_login:'Back to login page',
    processing_resend_email:'Our system is currently sending you an email to allow you to activate your account',
    resend_verify_email_success:'Email sent with success',
    resend_verify_email_error:'Error : Email has not been sent. Please contact administrator',

    password_updated_success:'Password has been updated with success. Redirecting to login page.',
    password_updated_error:'Error : Password has not been updated. Please contact administrator',
    forgot_password_email_sent:'Email sent with success',
    processing_reset_password_email:'Our system is currently sending you an email to allow you to reset your password',
    error_when_send_email:'Error : Email has not been sent, please verify your account',

    register: 'Register',
    name: 'Name',
    enter_name:'Enter Name',
    email_id:'Email',
    enter_email: 'Enter Email',
    affiliation: 'Affiliation',
    select_affiliation: 'Select Affiliation',
    head_office: 'Head Office',
    branch_office: 'Branch Office',
    site_office: 'Site Office',
    position: 'Position',
    select_position: 'Select Position',
    統括所長:'統括所長',
    project_manager:'Project Manager',
    副所長1:'副所長1',
    課長1_現場: '課長1 (現場)',
    副所長2:'副所長2',
    課長_現場:'課長 (現場)',
    主任1_現場: '主任1 (現場)',
    主任2_現場: '主任2 (現場)',
    係_現場:'係 (現場)',
    支店_Branch: '支店 (Branch)',
    Other:'Other',
    group_type:'Group Type',
    new_password:'New Password',
    enter_password:'Enter Password',
    confirm_new_password: 'Confirm New Password',
    submit:'Submit',
    already_have_an_account: 'Already have an account?',
    sign_in: 'Sign In',
    keep_me_login: 'Keep me logged in',

    please_reset_your_password:'Please reset your password',
    please_insert_the_one_time_password_you_sent_by_email:'Please insert the one-time password you sent by email',
    password_reset_if_you_do_not_receive_an_email_with_a_one_time_password_immediately_check_your_junk_email_folder: 'Password reset If you do not receive an email with a one-time password immediately, check your junk email folder',
    one_time_password: 'one-time password',
    response_one_time_password_otp: 'Response one-time password [OTP]',
    please_return_to_login_page:'Please return to the login page',
    something_went_wrong: 'Something went wrong!',
    update_succesfully: 'Update succesfully!',

};

export default locale;
